import React from 'react'

import Section from '../../../../../../components/Section'
import { Structure } from '../../../../Org/Structure/types'
import { Contract } from '../../../types'

type Props = {
    theme: string
    contract: Contract
    contractGuid: string
    structShortName: string | null
    structShortGuid: string | null
    structList: Structure[]
}

const ContractCardPurchaseInfo: React.FC<Props> = (props) => {
    return (
        <Section title="Информация о закупке">
            <div className="flex flex-col w-full gap-5 mt-2">
                {props.contract.notice_not_placed_by_fz223_p5_s4 ? (
                    <div className="flex flex-row w-full gap-5">
                        <div className="flex flex-col min-w-[200px]">
                            <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Извещение о закупке
                            </div>
                            <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                Извещение не размещалось в соответствии с ч.5
                                ст. 4 Федерального Закона № 223-ФЗ
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}

                {props.contract.purchase_notice_number ? (
                    <div className="flex flex-row w-full gap-5">
                        <div className="flex flex-col min-w-[200px]">
                            <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Извещение о закупке
                            </div>
                            <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                {props.contract.purchase_notice_number}
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}

                <div className="flex flex-row w-full gap-5">
                    <div className="flex flex-col min-w-[200px]">
                        <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Способ закупки
                        </div>
                        <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                            {props.contract.purchase_type_info_name}
                        </div>
                    </div>
                </div>

                {props.contract.purchase_notice_name ? (
                    <div className="flex flex-row w-full gap-5">
                        <div className="flex flex-col min-w-[200px]">
                            <div className="flex w-full items-center justify-start text-[12.8px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Предмет закупки (лота)
                            </div>
                            <div className="flex flex-row w-full gap-3 items-center justify-start text-[12.8px] text-[#181818] dark:text-[#FFFFFF]">
                                {props.contract.lot_num +
                                    '. ' +
                                    props.contract.purchase_notice_name}
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        </Section>
    )
}

export default ContractCardPurchaseInfo
